import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import AlertDefinitions from 'automation-ui-canvas/utils/alertUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function addAlert(alertKey, messageOptions = {
  body: {}
}) {
  const definition = AlertDefinitions[alertKey];
  if (!definition) {
    throw new Error(`Unrecognized alertType ${alertKey} provided to getNotificationAction`);
  }
  const {
    type
  } = definition;
  const titleOptions = messageOptions.title;
  const bodyOptions = messageOptions.body;
  let body;
  let title;
  if (definition.body) {
    body = typeof definition.body === 'string' ? definition.body : definition.body(messageOptions.body);
  }
  if (definition.title) {
    title = typeof definition.title === 'string' ? definition.title : definition.title(messageOptions.body);
  }
  const messageContent = typeof body === 'string' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: body,
    options: bodyOptions
  }) : body;
  const titleContent = typeof title === 'string' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: title,
    options: titleOptions
  }) : title;
  return {
    type: ActionTypes.ADDED_ALERT,
    meta: {
      notification: {
        message: messageContent,
        titleText: titleContent,
        type
      }
    }
  };
}
export function removeAlert(alertKey) {
  return dispatch => {
    dispatch({
      type: ActionTypes.REMOVED_ALERT,
      alertKey
    });
  };
}
export function dismissMessage(key) {
  return dispatch => {
    dispatch({
      type: ActionTypes.DISMISSED_MESSAGE,
      key
    });
  };
}